var exports = {
  "kL": "x93eb46d8--40b3ac--container",
  "ng": "x93eb46d8--40b3ac--container--compact",
  "DD": "x93eb46d8--40b3ac--title",
  "pq": "x93eb46d8--40b3ac--info",
  "Qs": "x93eb46d8--40b3ac--content",
  "H9": "x93eb46d8--40b3ac--content--padding",
  "zE": "x93eb46d8--40b3ac--content--labeled",
};

module.exports = exports;
